import { useCallback } from 'react'
import { useParams, useSearchParams } from 'react-router'
import { useShallow } from 'zustand/react/shallow'

import { GetProductsQuery } from '@/api/type'
import { useMediaStore } from '@/store/useMediaStore'

export const useMediaFetch = () => {
  const { domain } = useParams<'domain'>()
  const [params] = useSearchParams()
  const { getProducts, products } = useMediaStore(useShallow((state) => state))

  const getMediaProducts = useCallback(() => {
    if (!domain) return
    const tagsParam = params.get('tags')
    const pageParam = params.get('page')
    if (pageParam === products?.current_page.toString()) return
    const minLengthParam = params.get('min')
    const maxLengthParam = params.get('max')

    const query: GetProductsQuery = {}

    // tags を数値配列に変換
    if (tagsParam) {
      // カンマ区切りの場合
      if (tagsParam.includes(',')) {
        query.tags = tagsParam.split(',').map(Number)
      } else {
        // 単一の値の場合
        query.tags = [Number(tagsParam)]
      }
    }

    if (pageParam) query.page = Math.max(1, Number(pageParam))
    if (minLengthParam) query.min_length = Number(minLengthParam)
    if (maxLengthParam) query.max_length = Number(maxLengthParam)
    const titleParam = params.get('title')
    if (titleParam !== null) query.title = titleParam

    console.log('getProducts', query)
    query.per_page = 60
    getProducts({ domain, ...query })
  }, [domain, getProducts, params, products?.current_page])

  const queryBuilder = useCallback(() => {
    const tagsParam = params.get('tags')
    const pageParam = params.get('page')
    // if (pageParam === products?.current_page.toString()) return {}
    const minLengthParam = params.get('min')
    const maxLengthParam = params.get('max')
    const orderByParam = params.get('order_by')
    const favoriteParam = params.get('favorite')
    const readingStatusParam = params.get('reading_status')

    const query: GetProductsQuery = {}

    // tags を数値配列に変換
    if (tagsParam) {
      // カンマ区切りの場合
      if (tagsParam.includes(',')) {
        query.tags = tagsParam.split(',').map(Number)
      } else {
        // 単一の値の場合
        query.tags = [Number(tagsParam)]
      }
    }

    if (pageParam) query.page = Math.max(1, Number(pageParam))
    if (minLengthParam) query.min_length = Number(minLengthParam)
    if (maxLengthParam) query.max_length = Number(maxLengthParam)
    // デフォルトは登録順 (created_at)。バックエンドのデフォルトが upload_date のため明示的に送る
    query.order_by = orderByParam ?? 'created_at'
    const orderParam = params.get('order')
    if (orderParam) query.order = orderParam
    if (favoriteParam) query.favorite = favoriteParam === 'true'
    if (readingStatusParam) query.reading_status = readingStatusParam.split(',')
    const titleParam = params.get('title')
    if (titleParam !== null) query.title = titleParam
    return query
  }, [params])

  return { getMediaProducts, queryBuilder }
}
